import { DynamicText as DynamicTextType } from '../../../../../../types/Survey/Element'
import { DynamicText as DynamicTextAnswerType } from '../../../../../../types/Survey/Analysis/Element'
import { Props } from './types'
import Core from './Core'
import { useSelector } from 'react-redux'
import props from '../../../../../../redux/props'

const DynamicText: React.FC<Props<DynamicTextType, DynamicTextAnswerType>> = ({ element, analysisElement }) => {
  const t = useSelector((s) => s[props.TRANSLATION])
  return (
    <div>
      <Core element={element} />
      <div className="mt-3">
        <div className="text-gray font-bold">
          {t.survey.analysis.dynamicText.totalAnswerCount}
          {analysisElement.textAnswers.length}
        </div>
        <div className="flex flex-col mt-3 max-h-60 overflow-x-hidden overflow-y-auto">
          {analysisElement.textAnswers.map((a, i) => (
            <div key={i} className="w-full border-t border-cyan border-opacity-20 first:border-none">
              {a}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default DynamicText
